/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import React, { useMemo } from "react";
import LayoutPublicRoutes from "@/src/containers/Layouts/LayoutPublicRoutes";
import LandingPageTeaser from "@/src/components/Teaser/LandingPageTeaser";
import PartnerLogoSection from "@/src/components/Sections/Generic/PartnerLogoSection/PartnerLogoSection";
import AttorneySection from "@/src/components/Sections/Generic/AttorneySection/AttorneySection";
import Container from "@/src/components/Container/Container";
import AlimonyCheckin from "@/src/components/Checkin/FamilyLawCheckin/Alimony/AlimonyCheckin";
import LinkedCardBox from "@/src/components/LinkedCardBox/LinkedCardBox";
import { alimonyTeaserCards } from "@/src/services/landingPageService";
import LpAlimonyAdvoCardMeta from "./AdvoCard/LpAlimonyAdvoCardMeta";
import LpAlimonyAragMeta from "./Arag/LpAlimonyAragMeta";
import { useCustomer } from "@/src/provider/Customer/CustomerProvider";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import HowItWorksSectionAlimony from "@/src/components/Sections/FamilyLaw/Alimony/HowItWorksSection/HowItWorksSectionAlimony";
import { PARTNER_IRIS } from "@/src/constants/partnerIris";

const getMetaDataByPartner = ({ partner }: { partner: string }) => {
  switch (partner) {
    case PARTNER_IRIS.ADVOCARD:
      return <LpAlimonyAdvoCardMeta />;
    case PARTNER_IRIS.ARAG:
      return <LpAlimonyAragMeta />;
    default:
      return null;
  }
};

const LpAlimonyPartner = ({ partner }: { partner: NonNullable<AbstractCase["acquisitionPartner"]> }) => {
  const { isLoggedIn } = useCustomer();

  const metaData = useMemo(() => getMetaDataByPartner({ partner }), [partner]);

  return (
    <LayoutPublicRoutes minimal={!isLoggedIn} clickableLogo={isLoggedIn}>
      {metaData}
      <LandingPageTeaser
        headline={"Beratung zum Thema Unterhalt"}
        subheadline={"Unterhalt berechnen und professionell beraten lassen"}
        teaserButtonText={"Unterhalt berechnen"}
        teaserButtonLink={isLoggedIn ? "/servicewelt" : "#top-checkin"}
      >
        <LinkedCardBox linkedCards={alimonyTeaserCards} />
      </LandingPageTeaser>
      <PartnerLogoSection partnerIri={partner} containerStyle={"settlementContainer"} />
      {!isLoggedIn && (
        <Container>
          <AlimonyCheckin checkinHeading={"Unterhaltsberechnung erstellen und Erstberatung vereinbaren"} idPrefix={"top"} partner={partner} />
        </Container>
      )}
      <HowItWorksSectionAlimony />
      <AttorneySection
        product={"familyLawCase"}
        subheading={"Sie möchten sich professionell und schnell unterstützen lassen? Wir helfen Ihnen - jederzeit und ortsunabhängig!"}
      />
      {!isLoggedIn && (
        <Container>
          <AlimonyCheckin checkinHeading={"Unterhaltsberechnung erstellen und Erstberatung vereinbaren"} idPrefix={"top"} partner={partner} />
        </Container>
      )}
    </LayoutPublicRoutes>
  );
};

export default LpAlimonyPartner;
